import { render, staticRenderFns } from "./page-sales-split-manage.vue?vue&type=template&id=8f77099e&scoped=true&"
import script from "./page-sales-split-manage.vue?vue&type=script&lang=js&"
export * from "./page-sales-split-manage.vue?vue&type=script&lang=js&"
import style0 from "./page-sales-split-manage.vue?vue&type=style&index=0&id=8f77099e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f77099e",
  null
  
)

export default component.exports